module.exports = __webpack_public_path__ + "2691ecbfb3b485f384e9128be7064ad9.MP3";